<template>
  <div class="details">
    <pages-chat :userID="userID" />
  </div>
</template>

<script>
import PagesChat from '@/components/pageChat/index.vue'

export default {
  name: 'MessageDetails',
  props: {
    userID: {
      type: String,
      require: true
    }
  },
  components: {
    PagesChat
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.details {
  height: 100vh;
}
</style>
